import { ScheduleTestID } from "@/constants/TestID";
import HomeResourcesCard, {
  HomeContentImage,
  NoopStorageKey,
} from "@/ui/components/home/HomeResourcesCard";
import { FAIconName, Icon, Text } from "@/ui/core";
import { Box, HStack, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

const ImageAssetPath =
  "@/assets/images/components/home_resources/pre-admissions-group-blurb.jpg";

enum BlurbConstants {
  AnalyticsTitle = "Pre-Admissions Group Blurb",
  BodyText = "Our free pre-admissions group is a great place to get your questions answered.",
  FooterText = "Register now",
  TitleText = "Looking to learn more?",
}

type PreAdmissionsGroupBlurbProps = {
  contentUrl: string;
};

const BlurbContent = ({ testID }: ViewWithTestID) => {
  return (
    <Box bottom={18} left={18} position="absolute" width="80%">
      <VStack
        backgroundColor={ColorToken.Secondary70}
        borderRadius={12}
        gap={4}
        padding={12}
      >
        <Text
          color={ColorToken.NeutralBackgroundPrimary}
          testID={joinTestIDs(testID, "blurb-title")}
          variant="bodyMedium"
        >
          {BlurbConstants.TitleText}
        </Text>
        <Text
          color={ColorToken.NeutralBackgroundPrimary}
          testID={joinTestIDs(testID, "blurb-body")}
          variant="caption"
        >
          {BlurbConstants.BodyText}
        </Text>
        <HStack gap={6}>
          <Text
            color={ColorToken.Secondary10}
            testID={joinTestIDs(testID, "blurb-footer")}
            variant="captionMedium"
          >
            {BlurbConstants.FooterText}
          </Text>
          <Icon
            color={ColorToken.Secondary10}
            name={FAIconName.ChevronRight}
            size="sm"
            testID={joinTestIDs(testID, "blurb-button")}
          />
        </HStack>
      </VStack>
    </Box>
  );
};

const PreAdmissionsGroupBlurb = ({
  contentUrl,
}: PreAdmissionsGroupBlurbProps) => {
  const baseTestID = ScheduleTestID.PreAdmissionsGroupBlurb;
  return (
    <HomeResourcesCard
      analyticsSource={PreAdmissionsGroupBlurb.name}
      analyticsTitle={BlurbConstants.AnalyticsTitle}
      contentUrl={contentUrl}
      shouldShowDismissButton={false}
      storageKey={NoopStorageKey}
      testID={baseTestID}
    >
      {/* eslint-disable-next-line @typescript-eslint/no-require-imports */}
      <HomeContentImage imageSource={require(ImageAssetPath)}>
        <BlurbContent testID={baseTestID} />
      </HomeContentImage>
    </HomeResourcesCard>
  );
};

export { BlurbConstants };
export default PreAdmissionsGroupBlurb;
